/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { PaginatedResponseWithErrorGeneric } from '../shared/paginated-response-with-error-generic';
import { GetHotkeysResponseJson } from './get-hotkeys-response-json';
import { GetHotkeysResult } from '../results/get-hotkeys-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { HotkeyInfoDto } from '../models/hotkey-info-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class GetHotkeysResponse extends PaginatedResponseWithErrorGeneric<GetHotkeysResponseJson, GetHotkeysResult> implements IResponseWithErrorGeneric<GetHotkeysResult> {
  public hotkeys: HotkeyInfoDto[];

  //<custom-body>
  constructor(response: HttpResponse<GetHotkeysResponse>) {
    super(response, GetHotkeysResult.Error);

    if (this.result !== GetHotkeysResult.Success) {
      return;
    }

    if (this.body.hotkeys != null) {
      this.hotkeys = this.body.hotkeys;
    }
  }
  //</custom-body>
}
